import { render, staticRenderFns } from "./site-prices-detail.vue?vue&type=template&id=13a0fd5e&"
import script from "./site-prices-detail.vue?vue&type=script&lang=js&"
export * from "./site-prices-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports